import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'

const isSimilarResolver: FieldResolver = (metadata: Metadata) =>
  ({ isSimilar: metadata.isSimilar() } as StreamData)

export default isSimilarResolver
